namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class AccountPickerDialog extends Serenity.TemplatedDialog<any> {

        private pickerGrid: AccountPickerGrid;

        constructor() {
            super();

            this.pickerGrid = new AccountPickerGrid(this.byId("PickerGrid"));
            this.dialogTitle = "Select Accounts";
        }

        protected getTemplate() {
            return `<div id="~_PickerGrid"></div>`;
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.buttons = [
                {
                    text: Q.text("Dialogs.OkButton"),
                    click: () => {
                        var selected = this.pickerGrid.selectedItems;
                        if (!selected.length) {
                            Q.notifyWarning("Please select some accounts!");
                            return;
                        }

                        if (!this.onSuccess || this.onSuccess(selected))
                            this.dialogClose();
                    }
                },
                {
                    text: Q.text("Dialogs.CancelButton"),
                    click: () => {
                        this.dialogClose();
                    }
                }
            ];
            return opt;
        }

        get selectedItems() {
            return this.pickerGrid.selectedItems;
        }

        get value() {
            return this.pickerGrid.value;
        }

        set value(value: string[]) {
            this.pickerGrid.value = value;
        }

        set criteria(value: any[]) {
            this.pickerGrid.criteria = value;
        }

        set hasModelTarget(modelCode: string) {
            this.pickerGrid.hasModelTarget = modelCode;
        }

        public onSuccess: (selected: AccountRow[]) => boolean;
    }
}